import { TabPanel } from '@mui/lab';
import Box from '@mui/material/Box';
import DataTable from '../../../../../shared/components/Table';
import { GridColDef } from '@mui/x-data-grid';
import { Button } from '../../../../../shared/components/button/Button';
import { StatusActions } from './StatusActions';
import { formatCurrency } from '../../../../../shared/utils/helpers/numbers';

const COLUMNS: GridColDef[] = [
  {
    field: 'prod_descricao',
    headerName: 'Serviço',
    headerAlign: 'left',
    align: 'left',
    width: 200,
    valueGetter: (value: any) => value,
  },
  {
    field: 'grupo_tributario',
    headerName: 'Grupo Tributário',
    headerAlign: 'left',
    align: 'left',
    valueGetter: (value: any) => value,
  },
  {
    field: 'quantidade',
    headerName: 'Qtd',
    headerAlign: 'left',
    align: 'left',
    valueGetter: (value: any) => value,
  },
  {
    field: 'value',
    headerName: 'Valor',
    headerAlign: 'left',
    align: 'left',
    valueGetter: (value: any) => formatCurrency(value, 2, 2),
  },
  {
    field: 'desconto',
    headerName: 'Desconto Item',
    headerAlign: 'left',
    align: 'left',
    width: 150,
    valueGetter: (value: any) => formatCurrency(value, 2, 2),
  },
  {
    field: 'desconto_rateado',
    headerName: 'Desconto Rateado',
    headerAlign: 'left',
    align: 'left',
    width: 150,
    valueGetter: (value: any) => formatCurrency(value, 2, 2),
  },
  {
    field: 'desc_outras_retencoes',
    headerName: 'Outras Retenções',
    headerAlign: 'left',
    align: 'left',
    width: 150,
    valueGetter: (value: any) => value,
  },
  {
    field: 'total',
    headerName: 'Total',
    headerAlign: 'left',
    align: 'left',
    width: 200,
    valueGetter: (value: any) => formatCurrency(value, 2, 2),
  },
];

interface TabServicoProps {
  values: any;
  duploClick?: boolean;
  handleOpenModalSearchService: () => void;
  handleDeleteService: (product: any) => void;
  handleEditService: (product: any) => void;
}

export const TabServico = ({
  values,
  duploClick,
  handleEditService,
  handleDeleteService,
  handleOpenModalSearchService,
}: TabServicoProps) => {

  const actionColumn: GridColDef = {
    field: 'status',
    headerName: '',
    width: 5,
    renderCell: (params) => (
      <StatusActions params={params} handleDelete={handleDeleteService} handleEdit={handleEditService} disabled={duploClick} />
    ),
  };

  return (
    <TabPanel value={'3'}>
      <Box className={'flex flex-row space-x-4 pb-4'}>
        <Button
          title={'Adicionar Serviço'}
          variant={'primary'}
          onClick={handleOpenModalSearchService}
          disabled={duploClick}
        />
      </Box>
      <div className={'grid grid-cols-8 gap-7'}>
        <Box className='col-span-8'>
          <DataTable
            height={'48vh'}
            columns={[...COLUMNS, ...[actionColumn]]}
            rows={values?.services_list?.map((item: any, index: number) => {
              return {
                ...item,
                id: index,
              };
            })}
            showFilter={false}
            showButtonToXlsx={false}
          />
        </Box>
      </div>
    </TabPanel>
  );
};
